import { ReactNode, MouseEvent } from 'react';
import styles from './NotificationBar.module.scss';
import { collapseAnimationDuration } from '../TextInput/TextInput';
import AnimateHeight from 'react-animate-height';
import IconButton from '../IconButton/IconButton';
import iconRefresh from '../../../assets/icon-refresh.svg';
import { Severity } from '../../types/enums';

export type Props = Readonly<{
    message: string;
    isVisible: boolean;
    severity: Severity;
    actionText?: string;
    actionCallback?: (mouseEvent: MouseEvent<HTMLElement>) => void;
    children?: ReactNode;
    testId?: string;
    dataCy?: string;
}>;

const NotificationBar = (props: Props): JSX.Element => {
    let baseStyles: string[];
    if (props.severity === Severity.ERROR) {
        baseStyles = [styles._notificationBar, styles['_notificationBar--error']];
    } else if (props.severity === Severity.WARNING) {
        baseStyles = [styles._notificationBar, styles['_notificationBar--warning']];
    } else {
        baseStyles = [styles._notificationBar, styles['_notificationBar--success']];
    }
    return (
        <AnimateHeight duration={collapseAnimationDuration} height={props.isVisible ? 'auto' : '0%'}>
            <div
                role="status"
                aria-live="polite"
                aria-atomic="true"
                aria-hidden={!props.isVisible}
                data-testid={props.testId}
                data-cy={props.dataCy}
                className={baseStyles.join(' ')}
            >
                {props.isVisible && props.message}
                {props.children}
                {props.actionText && <IconButton alt={props.actionText} icon={iconRefresh} onClick={props.actionCallback} />}
            </div>
        </AnimateHeight>
    );
};

NotificationBar.defaultProps = {
    severity: Severity.ERROR,
};

export default NotificationBar;
